import { render, staticRenderFns } from "./admin-stats-page.vue?vue&type=template&id=03309c4e&"
import script from "./admin-stats-page.vue?vue&type=script&lang=js&"
export * from "./admin-stats-page.vue?vue&type=script&lang=js&"
import style0 from "./admin-stats-page.vue?vue&type=style&index=0&id=03309c4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports